import { useBizyProfile } from '../../../queries/bizy-profile';

/**
 * The name Bizy greets the user by: the Bizy personalization nickname ("call
 * me JT") when set, matching how Bizy itself addresses the user (the system
 * prompt prefers bizy_nickname), falling back to the surface's own notion of
 * the user's first name. Shared by the web side panel and Bizy Desktop so
 * both greet identically. The settings modal shares the same query cache, so
 * a nickname edit there updates the greeting live.
 */
export function useBizyGreetingDisplayName(fallbackName: string, options?: { enabled?: boolean }): string;
export function useBizyGreetingDisplayName(fallbackName: string | undefined, options?: { enabled?: boolean }): string | undefined;
export function useBizyGreetingDisplayName(fallbackName: string | undefined, options: { enabled?: boolean } = {}): string | undefined {
	const { data: bizyPersonalProfile } = useBizyProfile({ enabled: options.enabled ?? true });
	const bizyNickname = bizyPersonalProfile?.fields.bizy_nickname?.trim();
	return bizyNickname || fallbackName;
}
